<template>
    <div>
        <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
            <PulseLoader :loading="loading"></PulseLoader>
        </div>
        <div v-if="!loading" class="row">
            <div class="col-md-12 col-sm-12 ">
                <div class="">
                    <div class="x_panel">
                        <h2 class="float-left">Critical Spare List</h2>
                        <ul class="nav navbar-right panel_toolbox align-right">
                          <li  v-if="isPermissionExist(PERMISSIONS.CRITICAL_SPARES_ITEM_REPORT_PRINT)">
                            <button
                              @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
                              <i class="fa fa-print" v-if="!isPrinting"></i>
                              <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
                              {{ isPrinting ? 'Printing...' : 'Print' }}
                            </button>
                          </li>
                          <li  v-if="isPermissionExist(PERMISSIONS.CRITICAL_SPARES_ITEM_REPORT_PRINT)">
                            <vue-excel-xlsx
                              ref="excel"
                              :data="excelData"
                              :columns="excelHeader"
                              :file-name="'Critical Spare Report List'"
                              :file-type="'xlsx'"
                              :sheet-name="'sheetname'"
                              :disabled="isPrinting"
                              class="btn btn-primary btn-sm float-right"
                            >
                              <div
                                @click.prevent="handleExportPrint('excel')"
                              >
                                <i class="fa fa-file-excel-o"></i>
                                {{ isPrinting ? 'Preparing...' : 'Excel' }}
                              </div>
                            </vue-excel-xlsx>
                          </li>
                            <li>
                                <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                            </li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12 ">
                                            <div class="justify-content-center">
                                                <ul class="nav navbar-left  align-left">
                                                    <li>
                                                        <button @click="selectLocation('')" :class="['btn btn-outline-info btn-sm', { active: '' === selectedLocation }]"> All <span class="badge badge-success"></span></button>
                                                    </li>
                                                    <li v-for="(item, index) in locations" :key="item.id">
                                                        <button @click="selectLocation(item.id)" :class="['btn btn-outline-info btn-sm', { active: item.id === selectedLocation }]"> {{item?.name}} <span class="badge badge-success">{{item?.items_count}}</span></button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-box table-responsive">
                                        <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                                        <p class="text-muted font-13 m-b-30"></p>

                                        <ItemTable :items="items?.data" :currentPage="Number(items?.current_page)" :perPage="Number(items?.per_page)" :isEmpty="isEmpty" :isReport="true"/>

                                        <Pagination :pagination="items" :getData="getData"/>

                                        <div id="printArea" style="display: none">
                                            <div style="text-align: center;line-height: 20px;">
                                                <h2 style="line-height: 10px;">{{ appName }}</h2>
                                                <h4 style="line-height: 10px;">Vessel Name: {{this.vessel_name}}</h4>
                                                <div style="line-height: 10px;" class="font-weight-bold">Critical Spare List</div>
                                                <div style="line-height: 10px;" class="font-weight-bold">{{ this.locationName ?? 'ALL'}}</div>
                                                <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                                                <ItemTable :items="printItems" :isPrinting="true" :isEmpty="isEmpty" :isReport="true"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import auth from '@/auth'
    import ItemTable from "./ItemTable.vue";
    import PermissionsMixin from "@/mixin/permissionsMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import printMixin from "@/mixin/printMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import Pagination from "@/components/Pagination/Pagination.vue";
    import {apiPrintData} from "@/utils/print";

    export default {
        mixins: [PermissionsMixin, goBackButtonMixin, printMixin],
        name: 'reports-critical-spares',
        components: {
            Pagination,
            ItemTable,
            PulseLoader
        },
        data() {
            return {
                loading: false,
                appName: process.env.VUE_APP_NAME,
                permissions: auth.getPermissionData(),
                vesselId: auth.getVesselId(),
                vessel_name: auth.getVesselName(),
                size: 200,
                isPrinting: false,
                offset: 20,
                items: [],
                locationName: '',
                selectedLocation: '',
                locations: [],
                printItems: [],
                excelHeader: [],
                excelData: [],
            }
        },
        mounted() {
            this.getData();
            this.getLocation();
        },
        methods: {
            selectLocation(locationId) {
                if (this.selectedLocation === locationId) {
                    this.selectedLocation = '';
                } else {
                    this.selectedLocation = locationId;
                }
                this.getData();
            },
            getLocation() {
                let params = {
                    vessel_id: this.vesselId,
                    critical_equipment: "Yes"
                };
                this.$http.get('/api/filter/get-location-wise-item', {params}).then(response => {
                    this.locations = response.data.success
                }).catch(e => {
                    console.log(e)
                })
            },
            isEmpty(obj) {
                if (obj != null) {
                    return true
                } else {
                    return false
                }
            },
          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Component Name': `${item?.components || ''}`,
                'Item Name': `${item?.name || ''}`,
                'Min Required': `${item?.min_order || ''}`,
                'Current ROB': `${item?.rob || ''}`,
                'Remarks': `${item?.description || ''}`,
              });
            });

            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vessel_id: this.vesselId,
                location_id: this.selectedLocation,
                is_all: 1
              };

              const res = await this.$http.get('/api/filter/critical-equipment-item', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Critical Spare Report List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },
            async handlePrint() {

                this.isPrinting = true;

                try {
                    const params = {
                        vessel_id: this.vesselId,
                        location_id: this.selectedLocation,
                        is_all: 1
                    };

                    const res = await this.$http.get('/api/filter/critical-equipment-item', {params});
                    this.printItems = res?.data?.success ?? [];

                    this.$nextTick(() => {
                        apiPrintData('printArea', 'Critical Equipment Item List');
                        this.isPrinting = false;
                    });

                } catch (error) {
                    console.error(error);
                    this.isPrinting = false;
                    printWindow.close();
                }
            },
            onPerPageChange() {
                this.getData(1);
            },
            getData(page = 1) {
                this.loading = true;
                let params = {
                    vessel_id: this.vesselId,
                    location_id: this.selectedLocation,
                    page: page,
                    is_all: 0,
                    offset: this.offset
                };
                this.$http.get('/api/filter/critical-equipment-item', {params}).then(response => {
                    this.items = response.data.success;
                    this.locationName = response.data.location_name;
                    this.loading = false;
                    console.log(response.data.success);
                }).catch(e => {
                    this.loading = false;
                    let response = e.response;
                    if (response.status === 422) {
                        if (response.data?.errors) {
                            const errors = response.data.errors;
                            for (const key in errors) {
                                this.$snotify.error(errors[key][0])
                            }
                        }
                    } else if (response.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    } else {
                        this.$snotify.error('Something went wrong')
                    }
                })
            },

        }
    }
</script>

<style></style>
